// extracted by mini-css-extract-plugin
module.exports = {"beta-badge":"lab-beta-badge_beta-badge__Tt_1v"};